// eslint-disable-next-line no-use-before-define
const getExcelReportDate = (date) => getDate(date);

const getDisplayDate = (date) => {
  if (date) {
    const a = new Date(date);
    return `${(`0${a.getMonth() + 1}`).slice(-2)
    }/${(`0${a.getDate()}`).slice(-2)
    // eslint-disable-next-line no-useless-concat
    }/` + `${a.getFullYear()}`;
  }

  return date;
};
const getDisplayDateFormat = () => 'MM/DD/YYYY';

const getDataGridDateFormat = () => ({ type: 'date', format: 'MM/dd/yy' });

const getDate = (date) => {
  if (date) {
    const a = new Date(date);
    return `${(`0${a.getMonth() + 1}`).slice(-2)
    }/${(`0${a.getDate()}`).slice(-2)
    }/${(`0${a.getFullYear()}`).slice(-2)}`;
  }

  return date;
};

// eslint-disable-next-line import/prefer-default-export
export {
  getExcelReportDate,
  getDataGridDateFormat,
  getDisplayDate,
  getDisplayDateFormat,
};
